import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezone'
})
export class TimezonePipe implements PipeTransform {
  transform(value: any, fromTimezone: string, toTimezone: string): any {
    return moment.tz(value, fromTimezone).tz(toTimezone).format();
  }
}